module.exports = require("pinia");